module.exports = __webpack_public_path__ + "img/csomagjaink_bg_1360.38b85f0c.png";